import React, { useState } from 'react';
import { createDataTable } from '@/components/DataTable';
import theme from './UsersTable.module.scss';
import { BygrUser } from '@/types';
import { useAsyncStateWithIsLoading } from '@/utils/hooks';
import { getUsers, getUsersExportUrl } from '@/services/users';
import { CustomLink, DateDisplay, DateDistanceDisplay, LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';

const DataTable = createDataTable<BygrUser>();

const UserTable: React.FC<{}> = () => {
    const [tableState, setTableState] = useState(DataTable.getInitialState('displayName'));
    const [data, , , isLoading] = useAsyncStateWithIsLoading(() => getUsers(tableState), [tableState], null);

    if (!data) {
        return <LoadingIndicator />;
    }

    return (
        <div>
            <h2>Users</h2>
            <DataTable
                exportUrl={getUsersExportUrl(tableState)}
                hasSearchField
                isLoading={isLoading}
                data={data.items}
                onStateChange={setTableState}
                state={tableState}
                totalItemCount={data.totalCount}
                className="table style-3">
                <DataTable.Column
                    header="Name"
                    field="displayName"
                    sortable
                    renderer={({ row, value }) => (
                        <CustomLink to={`/users/${row.id}`}>{value.trim() || row.email}</CustomLink>
                    )}
                />
                <DataTable.Column header="Email" field="email" sortable />
                <DataTable.Column
                    header="Last visit"
                    field="lastVisitDate"
                    sortable
                    renderer={(x) => x.value && <DateDistanceDisplay value={x.value} />}
                />
                <DataTable.Column
                    header="Registered"
                    field="registeredDate"
                    sortable
                    renderer={(x) => x.value && <DateDisplay value={x.value} />}
                />
                <DataTable.Column renderer={(x) => (x.value ? 'Yes' : 'No')} header="Is Buyer" field="isBuyer" sortable />
                <DataTable.Column renderer={(x) => (x.value ? 'Yes' : 'No')} header="Is Seller" field="isSeller" sortable />

                <DataTable.Column
                    header="Profiles"
                    field="profileMemberships"
                    renderer={(x) => (
                        <ul className={theme.profileList}>
                            {x.value.map((pm) => (
                                <li key={pm.profileId}>
                                    {pm.profileName} ({pm.profileType})
                                </li>
                            ))}
                        </ul>
                    )}
                />
                <DataTable.Column renderer={(x) => (x.value ? 'Yes' : 'No')} header="Is Paying" field="isPaying" sortable />
                <DataTable.Column header="Language code" field="selectedLanguageCode" sortable />

                <DataTable.Column
                    renderer={(x) => (x.value ? 'Yes' : 'No')}
                    header="Is CM Admin"
                    field="isCmAdmin"
                    sortable
                />
                <DataTable.Column
                    renderer={(x) => (x.value ? 'Yes' : 'No')}
                    header="Is AM Admin"
                    field="isAmAdmin"
                    sortable
                />
                <DataTable.Column
                    renderer={(x) => (x.value ? 'Yes' : 'No')}
                    header="Is QM Admin"
                    field="isQmAdmin"
                    sortable
                />
            </DataTable>
        </div>
    );
};
export default UserTable;
